const STEPS = [
    {
        n: 1,
        title: "Integration",
        body: "C-ORE integrates with all your company vitals — Tally, Zoho, Excel, QuickBooks, GST, Salesforce, Oracle, SAP and many more. No re-keying. No data leaves your stack.",
    },
    {
        n: 2,
        title: "Boardroom goes live",
        body: "Within 5 minutes your CFO, CEO, CMO and CTO activate — alongside the full C-ORE Intelligence suite. Real cash, real margins, real risk, real strategy. From day one.",
    },
    {
        n: 3,
        title: "Scaling with C-ORE",
        body: "As your business grows, C-ORE grows with you — new modules, deeper insights, and AI co-pilots that adapt to every stage from MSME to mid-market and beyond.",
    },
];

export default function HowItWorks() {
    return (
        <section className="steps" id="how-it-works" data-testid="v2-how-it-works">
            <div className="container steps__inner">
                <div className="steps__head reveal">
                    <span className="steps__eyebrow">How it works</span>
                    <h2 className="steps__title">Live in three steps.</h2>
                </div>
                <div className="steps__grid">
                    {STEPS.map((s) => (
                        <div
                            className="step__card reveal"
                            key={s.n}
                            data-testid={`v2-step-${s.n}`}
                        >
                            <div className="step__num">{s.n}</div>
                            <h3 className="step__title">{s.title}</h3>
                            <p className="step__body">{s.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
